export default {
  MuiDrawer: {
    styleOverrides: {
      paper: {
        padding: '0px 0px 0px 0px',
        border: 'none !important',
        borderRadius: '0px',
        boxShadow: 'none',
        backgroundColor: '#FFFFFF'
      },
      paperAnchorDockedLeft: {
        borderRight: 'solid 0px #ffffff !important'
      }
    }
  }
};
